import styled from 'styled-components'


export const ProgrammeStyle = styled.div`
  line-height: 1.2;
  font-size: 0.92em;

  .btn-outline-primary {
    border-color: #3b3e5b !important;
    color: #3b3e5b !important;
    &.active {
      color: #fff !important;
      background-color: #3b3e5b !important;
    }
    &:hover {
      color: #fff !important;
      background-color: #3b3e5b !important;
    }
  }
  
  .btn-outline-danger {
    border-color: #a11748 !important;
    color: #a11748 !important;
    &.active {
      color: #fff !important;
      background-color: #a11748 !important;
    }
    &:hover {
      color: #fff !important;
      background-color: #a11748 !important;
    }
  }

  .text-primary {
    color: #3b3e5b !important;
  }
  .text-danger {
    color: #a11748 !important;
  }
  hr {
    height: 2px !important;
    background-color: rgb(201, 200, 199) !important;
    margin: 0.5rem 0 !important;
  }

  // Add to calendar library
  .chq-atc {
    font-size: 0.9em;
    small {
      color: $primary;
      line-height: 1;
    }
    svg path {
      fill: $primary;
    }
    button {
      display: flex;
      align-items: center;
    }
  }

  // Buttons to select venue/day
  .filterBtns {
    left: 0;
    position: sticky;

    button {
      font-size: 0.85em;
      width: 200px;
    }
  }

  @media (max-width: 767px) {
    .onsite .hallTabs {
      word-spacing: 9999rem;
    }
  }

  .hallTabs {
    background: rgb(179, 30, 68);
    padding: 8px 24px;
    margin: 0px auto;
    width: 45%;
    border-radius: 5px 0px 0px;
    position: relative;
    border: none;

    &::before,
    &::after {
      content: '';
      position: absolute;
      z-index: 1;
      top: 0px;
      bottom: 0px;
      width: 1em;
      background: rgb(179, 30, 68);
    }

    &::before {
      left: -0.5em;
      transform: skew(-10deg);
      border-radius: 5px 0px 0px;
      @media (max-width: 767px) {
        display: none;
      }
    }

    &::after {
      right: -0.5em;
      box-shadow: rgb(0 0 0 / 40%) 2px 0px 2px;
      transform: skew(10deg);
      border-radius: 0px 5px 0px 0px;
    }

    &.deselected {
      background: rgb(201, 200, 199);
      &::after {
        background: rgb(201, 200, 199);
      }
    }
  }

  .sessionContainer {
    margin-top: -1px;
    border-top: 2px solid #b31e44;
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  }

  .hallContainer {
    display: none;
  }

  // Speaker
  .speakerBtn {
    cursor: pointer;
    img {
      transition: all 100ms ease-in;
    }
    &:hover {
      color: black;
      img {
        transform: scale(1.05);
      }
    }
  }
  .cardAction {
    color: #2c2738;

    .iconContainer {
      display: flex;
      align-items: flex-start;
      padding: 4px 10px;
      svg {
        width: 20px;
      }
      p {
        font-size: 75%;
        margin-top: 8px;
        margin-left: 4px;
      }
    }
  }
  .join-button {
    color: white;
    border: 1px solid #b31e44;
    background-color: white;
    padding: 0;
    display: block;
    width: 100%;
    margin: auto;
    text-decoration: none;

    span {
      background-color: #b31e44;
      display: block;
      margin: 2px;
      padding: 4px 12px;
      font-size: 80%;
      font-weight: 500;
    }
  }
`

